export default {"src":"/pro/_next/static/media/ton.341e3aac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};